import React, { useEffect, useMemo, useState } from "react";
import { Row, CardHeader, Card, CardBody, Container } from "reactstrap";
import { deleteBdeInterview, listOfBde } from "../../api/bdeApi";
import { Link } from "react-router-dom";
import Loader from "../../components/common/loader";
import BreadCrumb from "../../components/common/breadCrumb";
import { toast } from "react-toastify";
import DeleteModal from "../../components/common/deleteModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import NoResultsMessage from "../../components/noResultMessage";
import TableContainer from "../../components/common/tableContainer";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, HandleResponse } from "../../utils/helpers/common";
import { BdeLabel } from "../../common/constant/Bde";
import BaseButton from "../../components/BaseComponents/BaseButton";

const BDE = () => {
  document.title = BdeLabel.BDE;
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [listOfBdeData, setListOfBdeData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState();

  useEffect(() => {
    fetchBDE();
  }, []);

  const fetchBDE = () => {
    setLoading(true);
    listOfBde()
      .then((response) => {
        const data = response?.data?.data || [];
        setListOfBdeData(data);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  }
  const companyDelete = (companyId) => {
    setSelectedCompanyId(companyId);
    setDeleteModal(true);
  };

  const companyDeleteTodo = () => {
    setBtnLoading(true);
    setDeleteModal(false);

    deleteBdeInterview(selectedCompanyId, { isDeleted: true })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          fetchBDE();
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: CommonLabel.SrNo,
        Cell: ({ row }) => {
          const index = row?.index + 1;
          return <div>{index}</div>;
        },
      },
      {
        Header: BdeLabel.CompanyName,
        accessor: "company.companyName",
        filterable: false,
      },
      {
        Header: BdeLabel.ClientName,
        accessor: "client.clientName",
        filterable: false,
      },
      {
        Header: BdeLabel.EmployeeName,
        accessor: "authUser.developerName",
        filterable: false,
      },
      {
        Header: BdeLabel.AlisedName,
        accessor: "alisedName.alisedName",
        filterable: false,
      },
      {
        Header: BdeLabel.YearOfExp,
        accessor: "yearOfExperience",
        Cell: ({ row }) => {
          const index = `${row?.original?.yearOfExperience}`;
          return <div>{index}+</div>;
        },
        filterable: false,
      },
      {
        Header: BdeLabel.Technology,
        accessor: "bdeTechnology[0].technology.techName",
        filterable: false,
      },
      {
        Header: BdeLabel.DateOfInterview,
        accessor: "dateOfInterview",
        Cell: (cell) => {
          const date = cell?.row?.original?.dateOfInterview;
          return (
            <div>
              {dateFormat(date) !== CommonLabel.InvalidDate
                ? dateFormat(date)
                : HandleResponse.NoData}
            </div>
          );
        },
      },
      {
        Header: BdeLabel.ScheduleBy,
        accessor: "schedule.developerName",
        filterable: false,
      },
      {
        Header: CommonLabel.Status,
        accessor: "status",
        filterable: false,
      },
      {
        Header: BdeLabel.Round,
        accessor: "round",
        filterable: false,
      },
      {
        Header: BdeLabel.Remark,
        accessor: "remark",
        Cell: (cell) => {
          let remark = cell?.row?.original?.remark;
          return remark || HandleResponse.NoData;
        },
        filterable: false,
      },
      {
        Header: CommonLabel.Action,
        Cell: (cellProps) => {
          return (
            <div>
              <div className="hstack gap-2">
                <ReactTooltip
                  place="bottom"
                  variant="info"
                  content={CommonLabel.Update}
                  anchorId={`editBde-${cellProps?.row?.original?.id}`}
                />
                <Link
                  to={`/bde/edit-bde/${cellProps?.row?.original?.id}`}
                  className="btn btn-sm btn-soft-info edit-list"
                  id={`editBde-${cellProps?.row?.original?.id}`}
                >
                  <i className="ri-pencil-fill align-bottom" />
                </Link>
                <ReactTooltip
                  place="bottom"
                  variant="error"
                  content={CommonLabel.Delete}
                  anchorId={`deleteBde-${cellProps?.row?.original?.id}`}
                />
                <Link
                  className="btn btn-sm btn-soft-danger remove-list"
                  onClick={() => companyDelete(cellProps?.row?.original?.id)}
                  id={`deleteBde-${cellProps?.row?.original?.id}`}
                >
                  <i className="ri-delete-bin-5-fill align-bottom" />
                </Link>
              </div>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => companyDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        loader={btnLoading}
      />
        <Container fluid>
          <BreadCrumb title="BDE" pageTitle="HRMS" />
          <Row className="mb-4">
            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                <Link to={"/bde/add-bde"} className="btn btn-primary">
                  <i className="ri-add-line align-bottom"></i> {BdeLabel.AddBDE}
                </Link>
              </div>
            </div>
          </Row>
          <Card>
            <CardHeader className="align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">{BdeLabel.BDE}</h4>
            </CardHeader>
            <CardBody>
              {(listOfBdeData?.length || loading) ? (
                <TableContainer
                  columns={columns}
                  data={listOfBdeData}
                  isAddUserList={false}
                  tableLoader={loading}
                  isGlobalFilter={true}
                  customPageSize={5}
                  divClass="table-responsive table-card mb-1"
                  tableClass="align-middle table-wrap"
                  theadClass="table-light text-muted"
                />
              ) : (
                <NoResultsMessage />
              )}
            </CardBody>
          </Card>
        </Container>
    </div>
  );
};

export default BDE;
